export default {
  "QUESTION": {
    "QUESTION": "Kérdés",
    "QUESTIONS": "Kérdések"
  }
}



// WEBPACK FOOTER //
// ./src/i18n/messages/hu/questions.js